import { appColors } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { CareerUserResponseSet, CareerQuestion } from '@backrs_ui/grow-ui/src/models/models';

import { View, Text, StyleSheet } from '@react-pdf/renderer';

import { makeAspirationMap } from '../util/results.util';

type AspirationsExplanationsPDFProps = Readonly<{
  userResponseSet: CareerUserResponseSet;
  questions: CareerQuestion[];
}>;

export const AspirationsExplanationsPDF = ({
  userResponseSet,
  questions,
}: AspirationsExplanationsPDFProps) => {
  const aspirationMap = makeAspirationMap(userResponseSet, questions, 'PDF');

  return (
    <View style={styles.container}>
      <View style={styles.chip}>
        <Text style={styles.chipTitle}>{appStrings.modules.results.aspirationsTitle}</Text>
      </View>
      <View style={styles.listContainer}>
        {Object.entries(aspirationMap).map(([key, value]) => (
          <Text key={key} style={styles.contentText}>
            {value}
          </Text>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: appColors.neutral.white,
    border: `1px solid ${appColors.neutral.black}`,
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 16,
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  chipTitle: {
    fontSize: 10,
    color: '#367FFF',
    fontWeight: 'bold',
  },

  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    paddingTop: 10,
  },
  chip: {
    backgroundColor: appColors.color.blue7,
    padding: 5,
    paddingHorizontal: 10,
    alignSelf: 'flex-start',
    borderRadius: 3,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  headerText: {
    fontSize: 12,
    fontWeight: 'bold',
    color: appColors.color.blue1,
  },
  contentText: {
    fontSize: 9,
  },
});
